import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import store, { persistor } from './store/store';

import { APP_TITLE, APP_DESCRIPTION } from './utils/constants';

ReactDOM.render(
	<React.StrictMode>
		<HelmetProvider>
			<Helmet>
				<title>{APP_TITLE}</title>
				<meta name='description' content={APP_DESCRIPTION} />
				<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap' />
				<meta name='viewport' content='initial-scale=1, width=device-width' />
			</Helmet>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<App />
					<ToastContainer />
				</PersistGate>
			</Provider>
		</HelmetProvider>
	</React.StrictMode>,
	document.getElementById('root')
);
